"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Span = exports.P = exports.Label = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Code = void 0;

var _utils = require("../utils");

var _createSemanticTextComponent = require("./createSemanticTextComponent");

var H1 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h1', {
  fontSize: 'T700',
  color: 'neutral90',
  fontWeight: 'light',
  // Override user agent stylesheet
  margin: 0
});
exports.H1 = H1;
var H2 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h2', {
  fontSize: 'T600',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
exports.H2 = H2;
var H3 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h3', {
  fontSize: 'T500',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
exports.H3 = H3;
var H4 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h4', {
  fontSize: 'T400',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
exports.H4 = H4;
var H5 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h5', {
  fontSize: 'T300',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
exports.H5 = H5;
var H6 = (0, _createSemanticTextComponent.createSemanticTextComponent)('h6', {
  fontSize: 'T200',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
exports.H6 = H6;
var P = (0, _createSemanticTextComponent.createSemanticTextComponent)('p', {
  fontSize: 'T300',
  color: 'neutral70',
  fontWeight: 'regular'
});
exports.P = P;
var Label = (0, _createSemanticTextComponent.createSemanticTextComponent)('label', {
  fontSize: _utils.LABEL_SIZE,
  color: _utils.LABEL_COLOR,
  fontWeight: 'regular'
});
exports.Label = Label;
var Span = (0, _createSemanticTextComponent.createSemanticTextComponent)('span', {
  display: 'inline'
});
exports.Span = Span;
var Code = (0, _createSemanticTextComponent.createSemanticTextComponent)('code', {
  display: 'inline',
  backgroundColor: 'neutral05'
});
exports.Code = Code;